(function () {
  'use strict';

  var countdown = document.getElementById('ea-countdown');
  if (!countdown) return;

  var target = new Date(countdown.getAttribute('data-target')).getTime();
  if (isNaN(target)) return;

  var $days  = document.getElementById('ea-days');
  var $hours = document.getElementById('ea-hours');
  var $mins  = document.getElementById('ea-mins');
  var $secs  = document.getElementById('ea-secs');

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function tick() {
    var now  = Date.now();
    var diff = target - now;
    if (diff <= 0) {
      $days.textContent = $hours.textContent = $mins.textContent = $secs.textContent = '00';
      countdown.classList.add('ea-countdown--done');
      clearInterval(timer);
      return;
    }
    $days.textContent  = pad(Math.floor(diff / 86400000));
    $hours.textContent = pad(Math.floor((diff % 86400000) / 3600000));
    $mins.textContent  = pad(Math.floor((diff % 3600000) / 60000));
    $secs.textContent  = pad(Math.floor((diff % 60000) / 1000));
  }

  tick();
  var timer = setInterval(tick, 1000);
})();